import { useEffect, useState } from "react";
import "./backToTop.component.css";

function BackToTopComponent() {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        // Button zeigen, sobald man mehr als 400px gescrollt hat.
        const onScroll = () => setVisible(window.scrollY > 400);
        window.addEventListener("scroll", onScroll);
        onScroll(); // direkt beim Laden einmal prüfen
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    function scrollTop() {
        // Immer an den echten Seitenanfang. scrollIntoView({block:"start"}) auf
        // ein Element liess frueher den Versatz der fixierten Navbar stehen, sodass
        // man "fast, aber nicht ganz" oben ankam. window.scrollTo(0,0) trifft den
        // Nullpunkt zuverlaessig. Zusaetzlich das scrollende Element direkt setzen,
        // falls nicht das Fenster, sondern ein Container scrollt.
        window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
    }

    if (!visible) return null;

    return (
        <button
            type="button"
            className="back-to-top"
            onClick={scrollTop}
            aria-label="Back to top"
        >
            <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <path
                    d="M12 19V5M12 5l-7 7M12 5l7 7"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        </button>
    );
}

export default BackToTopComponent;
